var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1908 5.42424C27.9774 6.2109 27.9774 7.47757 27.1908 8.2509L22.0041 13.4376L24.8308 25.6909L22.9508 27.5842L17.7774 17.6776L12.5774 22.8776L13.0574 26.1709L11.6308 27.5842L9.2841 23.3442L5.03076 20.9842L6.4441 19.5442L9.77743 20.0376L14.9374 14.8776L5.03076 9.66424L6.9241 7.78424L19.1774 10.6109L24.3641 5.42424C25.1108 4.6509 26.4441 4.6509 27.1908 5.42424Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlights);
export default __webpack_public_path__ + "static/media/flights.f624426779d4aecda764e71fdb0472f6.svg";
export { ForwardRef as ReactComponent };